import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
import { ImageBase } from '@/components/ui/Image/ImageBase';
import { Text } from '@/components/ui/Typography/Body/Text';
import { tailwindConfig } from '@/style/config';
/**
 * コンサルタントの性格を表示するためのコンポーネント
 * @param props
 * @constructor
 */
export const CSearchProPersonalityListItem = (props) => {
    const { className = '', color = tailwindConfig.theme.colors.black['700'], image = '', tagName = 'li', text, } = props;
    const textCss = css `
    color: ${color};
  `;
    const Tag = tagName;
    return (_jsxs(Tag, Object.assign({ className: clsx(className, 'flex items-center', 'gap-4') }, { children: [_jsx("div", Object.assign({ className: clsx('rounded-full', 'w-[25px] h-[25px]', 'overflow-hidden') }, { children: _jsx(ImageBase, { alt: '', src: image }) })), _jsx(Text, Object.assign({ color: 'none', css: textCss, size: 'xs' }, { children: text }))] })));
};
